import { h } from 'preact';
import styles from './Pagination.module.scss';
export function Pagination({ meta, currentPage, onChange, onLoadLess }) {
    const { totalPages, totalResults } = meta;
    const hasMore = currentPage < totalPages;
    // const showLoadLess = currentPage > 1;
    const itemsShown = currentPage * (meta.pageSize || 24);
    const displayedCount = Math.min(itemsShown, totalResults);
    // const scrollToTop = () => {
    //   window.scrollTo({ top: 0, behavior: 'smooth' });
    // };
    // if (!hasMore) {
    //   return null;
    // }
    return (h("div", { class: styles.pagination },
        h("div", { class: styles.buttonGroup }, hasMore && (h("button", { class: styles.loadMoreButton, onClick: () => onChange(currentPage + 1) }, "LOAD MORE"))),
        h("div", { class: styles.itemCount },
            displayedCount,
            "/",
            totalResults)));
}
